/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BraceletInputs */

const en_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bracelet`)
};

const es_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsera`)
};

const fr_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bracelet`)
};

const de_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armband`)
};

const ja_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブレスレット`)
};

const zh_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手链/手镯`)
};

const ar_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سوار`)
};

const id_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelang`)
};

const it_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bracciale`)
};

const ru_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Браслет`)
};

const pt_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulseira`)
};

const ko_val_bracelet = /** @type {(inputs: Val_BraceletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔찌`)
};

/**
* | output |
* | --- |
* | "Bracelet" |
*
* @param {Val_BraceletInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_bracelet = /** @type {((inputs?: Val_BraceletInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BraceletInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_bracelet(inputs)
	if (locale === "es") return es_val_bracelet(inputs)
	if (locale === "fr") return fr_val_bracelet(inputs)
	if (locale === "de") return de_val_bracelet(inputs)
	if (locale === "ja") return ja_val_bracelet(inputs)
	if (locale === "zh") return zh_val_bracelet(inputs)
	if (locale === "ar") return ar_val_bracelet(inputs)
	if (locale === "id") return id_val_bracelet(inputs)
	if (locale === "it") return it_val_bracelet(inputs)
	if (locale === "ru") return ru_val_bracelet(inputs)
	if (locale === "pt") return pt_val_bracelet(inputs)
	return ko_val_bracelet(inputs)
});